if ($('.js-afishaSlider').length > 0) {
	let afishaSlider = null;

	function afishaSliderInit(){
		afishaSlider = new Swiper($('.js-afishaSlider .swiper-container'), {
			speed: 600,
			slidesPerView: 6,
			spaceBetween: 30,
			navigation: {
				nextEl: '.js-afishaSliderNext',
				prevEl: '.js-afishaSliderPrev',
			},
		});
	}

	function afishaSliderApp(){
		if ($(window).width() <= 1199) {
			afishaSlider && afishaSlider.destroy(true, true);
		} else {
			afishaSliderInit();
		}
	}

	afishaSliderApp();

	$(window).on('resize', () => {
		afishaSliderApp();
	});
}
